(function () {
  // Header: mobile menu + search panel
  var header = document.querySelector('.site-header');
  if (header) {
    var menuBtn = header.querySelector('.menu-btn');
    if (menuBtn) menuBtn.addEventListener('click', function () {
      var open = header.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.sub-toggle').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.parentNode, open = li.classList.toggle('open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    var searchBtn = header.querySelector('.search-btn');
    var panel = header.querySelector('.search-panel');
    if (searchBtn && panel) searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      panel.hidden = !panel.hidden;
      searchBtn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      if (!panel.hidden) panel.querySelector('input').focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (header.classList.contains('open')) { header.classList.remove('open'); menuBtn && menuBtn.setAttribute('aria-expanded', 'false'); }
      if (panel && !panel.hidden) { panel.hidden = true; searchBtn && searchBtn.setAttribute('aria-expanded', 'false'); }
    });
  }

  // Mood rail tabs: each tab shows one panel
  document.querySelectorAll('[data-moods]').forEach(function (root) {
    var tabs = root.querySelectorAll('.tabs button');
    var panels = root.querySelectorAll('.rail-panel');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Cart: auto-submit on quantity change
  document.querySelectorAll('form[data-cart]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.matches('.qty input')) f.requestSubmit ? f.requestSubmit() : f.submit(); });
    var age = f.querySelector('[data-age-ok]');
    if (!age) return;
    var msg = f.querySelector('[data-age-msg]');
    var express = f.querySelector('[data-age-express]');
    function sync() {
      if (express) express.hidden = !age.checked;
      if (age.checked && msg) msg.hidden = true;
    }
    age.addEventListener('change', function () {
      sync();
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Age confirmed 18+': age.checked ? 'Yes' : '' } })
      }).catch(function () {});
    });
    sync();
    f.addEventListener('submit', function (e) {
      var s = e.submitter;
      if (s && s.name === 'checkout' && !age.checked) {
        e.preventDefault();
        if (msg) msg.hidden = false;
        age.focus();
      }
    });
  });

  // Product: gallery + variant picker
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImg = root.querySelector('.main-img img');
    root.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = b.dataset.src; mainImg.srcset = b.dataset.srcset || ''; mainImg.alt = b.dataset.alt || '';
        root.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });

    var json = root.querySelector('script[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var form = root.querySelector('form[action*="/cart/add"]');

    function selected() {
      var opts = [];
      root.querySelectorAll('.option').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null);
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { if (!addBtn) return; addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; return; }
      idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      }
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.srcset = ''; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('.option input').forEach(function (i) { i.addEventListener('change', update); });
  });

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  // Video hero: the header floats over it until the page scrolls
  var vhero = document.querySelector('[data-vhero]');
  if (vhero && header && vhero.closest('.shopify-section') === document.querySelector('main .shopify-section')) {
    var setH = function () { document.documentElement.style.setProperty('--hh', header.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);
    header.classList.add('over');
    var onScroll = function () { header.classList.toggle('solid', window.scrollY > 40); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    var hv = vhero.querySelector('video');
    if (hv && still) { hv.pause(); hv.removeAttribute('autoplay'); }
  }

  // Video chapters: play on hover, or while in view on touch screens
  document.querySelectorAll('[data-chapters] .ch').forEach(function (c) {
    var v = c.querySelector('video');
    if (!v || still) return;
    var play = function () {
      if (!v.src) v.src = v.dataset.src;
      c.classList.add('on');
      var p = v.play(); if (p) p.catch(function () {});
    };
    var stop = function () { c.classList.remove('on'); v.pause(); };
    if (touch && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? play() : stop(); }); }, { threshold: 0.6 }).observe(c);
    } else {
      c.addEventListener('mouseenter', play);
      c.addEventListener('mouseleave', stop);
      c.addEventListener('focus', play);
      c.addEventListener('blur', stop);
    }
  });

  // Pleasure finder: three taps, then the matching collection with a price filter
  document.querySelectorAll('[data-finder]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-finder-map]').textContent);
    var q = root.querySelector('[data-q]'), steps = root.querySelector('[data-steps]');
    var picks = [];
    var lists = [data.who, data.mood, data.budget];
    function draw() {
      var i = picks.length;
      q.textContent = data.q[i];
      steps.innerHTML = '';
      lists[i].forEach(function (label, n) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'chip'; b.textContent = label.trim();
        b.addEventListener('click', function () { b.classList.add('on'); picks.push(n); setTimeout(next, 220); });
        steps.appendChild(b);
      });
    }
    function next() {
      if (picks.length < 3) return draw();
      q.textContent = data.done;
      var url = data.urls[picks[0]][picks[1]];
      window.location.href = url + (url.indexOf('?') < 0 ? '?' : '&') + data.prices[picks[2]];
    }
    draw();
  });
})();
